import { Modal, Form, Input, Row, Col, Card } from "antd";
import { useEffect } from "react";
import { ShopOutlined } from "@ant-design/icons";
import { cardHeaderStyle, cardStyle, CardTitle } from "../ingresosPOCardStyles";

export default function ProveedorPOForm({ open, onCancel, onSubmit, initialValues }) {

  const [form] = Form.useForm();

  useEffect(() => {
    if (initialValues) {
      form.setFieldsValue(initialValues);
    } else {
      form.resetFields();
    }
  }, [initialValues]);

  const handleOk = () => {
    form
      .validateFields()
      .then((values) => {
        onSubmit(values);
        form.resetFields();
      });
  };

  return (
    <Modal
      open={open}
      title={initialValues ? "Editar proveedor" : "Nuevo proveedor"}
      okText="Guardar"
      cancelText="Cancelar"
      onCancel={onCancel}
      onOk={handleOk}
      width={560}
      destroyOnClose
    >
      <Form form={form} layout="vertical" component={false}>
        <Card
          style={{ ...cardStyle, marginBottom: 0 }}
          styles={{ header: cardHeaderStyle, body: { padding: 20 } }}
          title={<CardTitle icon={<ShopOutlined />}>Datos del proveedor</CardTitle>}
        >
          <Row gutter={[20, 8]}>
            <Col span={24}>
              <Form.Item
                label="Nombre"
                name="nombre"
                rules={[{ required: true, message: "Ingrese el nombre" }]}
              >
                <Input size="large" placeholder="Nombre del proveedor" />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item label="Identificación" name="identificacion">
                <Input size="large" placeholder="NIT o identificación" />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item label="Dirección" name="direccion">
                <Input size="large" placeholder="Dirección del proveedor" />
              </Form.Item>
            </Col>
          </Row>
        </Card>
      </Form>
    </Modal>
  );
}
